<template>
  <body v-show="startRender">
    <div class="modal winner">
      <div class="modal-in">
        <a class="close"></a>
        <h2>
          <span>{{ plusAmount }}FUS</span>당첨!!
        </h2>
        <h3>
          <div class="item">
            <img v-for="(num, index) in gameResult" :key="index" :src="'images/img/slot-' + gameResultIcons[num - 1] + '.png'" alt="" />
          </div>
        </h3>
        <div class="cont">
          <p>축하합니다. {{ plusAmount }}FUS에 당첨되셨습니다.</p>
          <p>당첨된 FUS는 바로 보유FUS에 지급되어 합산됩니다.</p>
        </div>
      </div>
    </div>
    <div class="help">
      <!-- :style="startRender ? 'visibility:visible': 'visibility:hidden'" -->
      <div class="open">
        <p style="white-space: inherit">사용자가 참여하여 해당 아이템을 채굴하는 게임입니다.</p>
        <p>당첨된 FUS는 바로 지급되어 합산됩니다.</p>
        <p>보유한 채굴권을 소모하여 참여가 가능합니다.</p>
        <p>비정상적 방법을 이용한 경우 획득한 FUS는 모두 회수됩니다.</p>
      </div>
      <a href="javascript:void(0)" class="toggle"></a>
    </div>
    <a href="javascript:window.history.back();" class="close-this"><img src="images/basic/icon/close-big-w.svg" alt="" /></a>

    <div class="wrap">
      <div class="slot-content">
        <div class="title">
          <img src="images/basic/img/slot-title.png" alt="" style="width: 368px; height: 90px; margin: auto" />
          <template v-if="check == true">
            <h4 class="remain">
              <span>채굴권 획득 가능!</span>
              <a class="get" @click="startNativeAd()">채굴권 받기</a>
            </h4>
          </template>
          <template v-else>
            <h4 class="remain">
              <span>{{ timeText }}</span
              >후에 채굴권 획득 가능
            </h4>
          </template>
        </div>
        <div class="slotmachine">
          <div class="disable on" v-show="ticketCnt < 1 && spinEnable">
            <h3>채굴권이 필요합니다.</h3>
            <p>채굴권은 앱내 다양한 활동으로<br />획득 가능합니다.</p>
            <div class="btns">
              <a href="#" class="impor" @click="startNativeAd()">채굴권 획득</a>
              <!-- <a href="#">채굴권 획득</a> -->
            </div>
          </div>
          <div class="frame">
            <div class="dummy" style="display: none">{{ accountCoin }}</div>
            <div class="bet">
              <dl>
                <dt>보유 FUS</dt>
                <dd class="current">
                  <ul v-for="count in bigAccountCoinLen" :key="count" data-playslot="1" style="top: -360px" class="count number">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  <!--
                  <ul class="count" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  <ul class="count" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  <ul class="count" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  <ul class="count" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  <ul class="count" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  -->
                  <span class="point"></span>
                  <ul class="count decimal" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                  <ul class="count decimal" data-playslot="1" style="top: -360px">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <li>0</li>
                  </ul>
                </dd>
              </dl>

              <!-- 
                 <dl>
                     <dt>베팅</dt>
                     <dd class="bet-count">
                        100
                     </dd>
                  </dl>
                  <div class="crease">
                     <a href="#" class="up"><img src="images/btn/increase.svg" alt=""></a><a href="#" class="down"><img
                           src="images/btn/decrease.svg" alt=""></a>
                  </div> 
               -->
            </div>
            <div class="spector"></div>
            <div class="spinner slotwrapper" v-show="startRender" id="game_spinner">
              <ul class="slot">
                <li number="1"><img src="images/img/slot-bonus.png" alt="" /></li>
                <li number="2"><img src="images/img/slot-bell.png" alt="" /></li>
                <li number="3"><img src="images/img/slot-jwel.png" alt="" /></li>
                <li number="4"><img src="images/img/slot-money.png" alt="" /></li>
                <li number="5"><img src="images/img/slot-clover.png" alt="" /></li>
                <li number="6"><img src="images/img/slot-heart.png" alt="" /></li>
                <li number="7"><img src="images/img/slot-grape.png" alt="" /></li>
                <li number="8"><img src="images/img/slot-seven.png" alt="" /></li>
                <li number="9"><img src="images/img/slot-thehae.png" alt="" /></li>
              </ul>
              <ul class="slot">
                <li number="1"><img src="images/img/slot-bonus.png" alt="" /></li>
                <li number="2"><img src="images/img/slot-bell.png" alt="" /></li>
                <li number="3"><img src="images/img/slot-jwel.png" alt="" /></li>
                <li number="4"><img src="images/img/slot-money.png" alt="" /></li>
                <li number="5"><img src="images/img/slot-clover.png" alt="" /></li>
                <li number="6"><img src="images/img/slot-heart.png" alt="" /></li>
                <li number="7"><img src="images/img/slot-grape.png" alt="" /></li>
                <li number="8"><img src="images/img/slot-seven.png" alt="" /></li>
                <li number="9"><img src="images/img/slot-thehae.png" alt="" /></li>
              </ul>
              <ul class="slot">
                <li number="1"><img src="images/img/slot-bonus.png" alt="" /></li>
                <li number="2"><img src="images/img/slot-bell.png" alt="" /></li>
                <li number="3"><img src="images/img/slot-jwel.png" alt="" /></li>
                <li number="4"><img src="images/img/slot-money.png" alt="" /></li>
                <li number="5"><img src="images/img/slot-clover.png" alt="" /></li>
                <li number="6"><img src="images/img/slot-heart.png" alt="" /></li>
                <li number="7"><img src="images/img/slot-grape.png" alt="" /></li>
                <li number="8"><img src="images/img/slot-seven.png" alt="" /></li>
                <li number="9"><img src="images/img/slot-thehae.png" alt="" /></li>
              </ul>
            </div>
          </div>

          <div class="start"><a href="#" @click="useTicket()">SPIN!</a></div>
          <div class="ticket">
            <div class="select-mine">
              <p class="mine-ticket">보유채굴권: {{ ticketCntView }}</p>
            </div>
          </div>
        </div>
        <div class="score">
          <table cellpadding="0">
            <tbody>
              <tr v-for="(i, row_index) in winInfoList.length / 3" :key="row_index">
                <td v-for="(p, index) in winInfoList.length / 3" :key="index">
                  <div class="items">
                    <div class="item">
                      <img :src="`images/basic/img/slot-${winInfoIcons[p - 1 + (i - 1) * 3]}.png`" alt="" />
                      <img :src="`images/basic/img/slot-${winInfoIcons[p - 1 + (i - 1) * 3]}.png`" alt="" />
                      <img :src="`images/basic/img/slot-${winInfoIcons[p - 1 + (i - 1) * 3]}.png`" alt="" />
                    </div>
                    <p>+{{ winInfoList[p - 1 + (i - 1) * 3].fusAmount }}</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="log">
        <ul class="list">
          <li class="winner" v-for="(user, idx) in userList" :key="idx">
            <div class="profile" :style="`background-image: url(${user.userInfo.myPhotoUrl}), url(/images/basic/img/default.svg) ;border-radius:50%`"></div>
            <div class="infos">
              <p>{{ user.joinText }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </body>
</template>

<script>
import Vue from "vue";
import VueHead from "vue-head";
import { timeCheck, create, use, check } from "@/api/mining";
import $ from "jquery";
import playSpinVue from "@/js/slotmachine.js";
Vue.use(VueHead);
export default {
  head: {
    title: {
      inner: "더해-블록체인 커뮤니티 플랫폼",
    },
    meta: [{ charset: "UTF-8" }, { name: "viewport", content: '"width = device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover' }, { name: "apple-mobile-web-app-title", content: "더해" }, { name: "apple-mobile-web-app-capable", content: "yes" }, { name: "msapplication-TileColor", content: "#ffffff" }, { name: "theme-color", content: "#ffffff" }, { name: "msapplication-TileImage", content: "/ms-icon-144x144.png" }, { name: "apple-mobile-web-app-status-bar-style", content: "default" }, { property: 'og:url"', content: "" }, { property: 'og:title"', content: "더해" }, { property: 'og:type"', content: "website" }, { property: 'og:image"', content: "images/favicon/og.png" }, { property: 'og:description"', content: "즐거움과 혜택이 더해지는 커뮤니티 플랫폼" }],
    link: [
      { rel: "stylesheet", type: "text/css", href: "stylesheets/slotmachine.css" },
      { rel: "apple-touch-icon", sizes: "57x57", href: "images/favicon/apple-icon-57x57.png" },
      { rel: "apple-touch-icon", sizes: "60x60", href: "images/favicon/apple-icon-60x60.png" },
      { rel: "apple-touch-icon", sizes: "72x72", href: "images/favicon/apple-icon-72x72.png" },
      { rel: "apple-touch-icon", sizes: "76x76", href: "images/favicon/apple-icon-76x76.png" },
      { rel: "apple-touch-icon", sizes: "114x114", href: "images/favicon/apple-icon-114x114.png" },
      { rel: "apple-touch-icon", sizes: "120x120", href: "images/favicon/apple-icon-120x120.png" },
      { rel: "apple-touch-icon", sizes: "144x144", href: "images/favicon/apple-icon-144x144.png" },
      { rel: "apple-touch-icon", sizes: "152x152", href: "images/favicon/apple-icon-152x152.png" },
      { rel: "apple-touch-icon", sizes: "180x180", href: "images/favicon/apple-icon-180x180.png" },
      { rel: "icon", type: "image/png", sizes: "192x192", href: "images/favicon/android-icon-192x192.png" },
      { rel: "icon", type: "image/png", sizes: "32x32", href: "images/favicon/favicon-32x32.png" },
      { rel: "icon", type: "image/png", sizes: "96x96", href: "images/favicon/favicon-96x96.png" },
      { rel: "icon", type: "image/png", sizes: "16x16", href: "images/favicon/favicon-16x16.png" },
    ],

    script: [
      { type: "text/javascript", src: "javascripts/js/jquery.min.js" },
      { type: "text/javascript", src: "javascripts/js/jquery.easing.1.3.js" },
      //{ type: 'text/javascript', src: 'javascripts/js/slotmachine.js'      }
    ],
  },
  data() {
    return {
      startRender: false,
      isInitJquery: false,

      ticketCntView: "",
      tempTicketCnt: 0,
      gameResult: [],
      timeText: "",
      check: false,
      second: 0,

      // check.do
      userList: [],
      winInfoList: [],

      current_coin_array: [],
      // modal value
      gameResultIcons: ["bonus", "bell", "jwel", "money", "clover", "heart", "grape", "seven", "thehae"],
      winInfoIcons: ["thehae", "seven", "grape", "heart", "clover", "money", "jwel", "bell", "bonus"],
      plusAmount: "",
      xFus: 0,

      // slot value
      spinEnable: true,
      bigAccountCoinLen:5,

    };
  },
  beforeCreate() {
    //this.addScript();
  },
  created() {
    // remove common css
    if($('link[href*="/stylesheets/reset.css"]')[0])$('link[href*="/stylesheets/reset.css"]')[0].remove();
    if($('link[href*="/stylesheets/style.css"]')[0])$('link[href*="/stylesheets/style.css"]')[0].remove();

    //this.adTimeCheck();
    //this.checkList();
  },
  mounted() {
    this.adTimeCheck();
    this.checkList();
    window.VueRoot = this;

    //슬롯머신 소스 https://momokang.github.io/slotmachine/

    /**
     * 광고가 끝나면 mobile에서 call
     * 프론트에서 광고를 이미본 사람이라면 call
     */
  },
  updated() {},
  computed: {
    accountCoin() {
      var accountCoin = this.$store.state.userInfo.accountCoin == undefined ? 0 : this.$store.state.userInfo.accountCoin;
      return accountCoin;
    },
    ticketCnt() {
      if (this.$store.state.userInfo.ticketCnt == undefined) {
        return 0;
      } else {
        return this.$store.state.userInfo.ticketCnt;
      }
    },
  },
  methods: {
    addScript() {
      let scripts = ["javascripts/js/jquery.min.js", "javascripts/js/jquery.easing.1.3.js", "javascripts/js/slotmachine.js"];
      for (let i = 0, len = scripts.length; i < len; i++) {
        let script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", scripts[i]);
        document.getElementsByTagName("body")[0].appendChild(script);
      }
    },

    /**
     * 네이티브 전명광고 시청이 필요할 경우
     * 해당 메소드 호출을 통해 native 전면광고 실행
     */
    startNativeAd() {
      var varUA = navigator.userAgent.toLowerCase();
      if (varUA.indexOf("android") > -1) {
        //ANDDROID
        try {
          window.Android.platInterstitialAd("AD2");
        } catch {
          window.Android.playRewardAd();
        }
      } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
        //IOS
        window.webkit.messageHandlers.platInterstitialAd.postMessage("AD2");
        //playSpin();
      } else {
        //아이폰, 안드로이드 외
        playSpin();
      }
    },
    playSpinVueBridge() {
      playSpin();
    },
    currentFusSpin() {
      var floor_coin = this.accountCoin;
      this.bigAccountCoinLen = parseInt(floor_coin).toString().length
      this.bigAccountCoinLen = this.bigAccountCoinLen < 5 ? 5: this.bigAccountCoinLen;
      var temp_array = [];
      for(var j=0; j< (this.bigAccountCoinLen+2) ; j++){
        temp_array.push(0);
      }
      this.current_coin_array = temp_array;
      var current_push_cnt = temp_array.length;
      var pow_v = (current_push_cnt-3);
      for (var i = 0; i < current_push_cnt; i++) {
        if (i < current_push_cnt-2) {
          this.current_coin_array[i] = parseInt((floor_coin / Math.pow(10, pow_v - i)) % 10);
        } else {
          this.current_coin_array[i] = parseInt((floor_coin * Math.pow(10, i - pow_v)).toFixed(2) % 10);
        }
      }
      var fixed_array = this.current_coin_array == undefined ? temp_array : this.current_coin_array;
      setTimeout(function () {
        $(".current ul").playSpin({
          time: 500,
          stopSeq: "leftToRight",
          endNum: fixed_array,
        });
      }, 500);
      
    },
    adTimeCheck() {
      timeCheck({
        adType: "AD2",
      }).then(({ data }) => {
        this.check = data.check;
        this.second = data.second;
        if (this.second > 0) {
          this.uiSetTimeText();
        }
      });
    },
    uiSetTimeText() {
      this.interval = setInterval(function () {
        window.VueRoot.second--;
        var sec_num = window.VueRoot.second; // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        var timeTextStr = hours + ":" + minutes + ":" + seconds;
        window.VueRoot.timeText = timeTextStr;
        if (sec_num < 0) {
          clearInterval(window.VueRoot.interval);
          window.VueRoot.adTimeCheck();
        }
      }, 1000);
    },
    useTicket() {
      if (!this.spinEnable) return;
      this.spinEnable = false;
      use({
        gameType: "slot",
      }).then(({ data }) => {
        this.plusAmount = data.plusAmount;
        this.ticketCntView = data.ticketCntView;
        this.tempTicketCnt = parseInt(data.ticketCnt);
        window.VueRoot.$store.commit("udtTicketCnt", window.VueRoot.tempTicketCnt);
        this.gameResult = data.gameResult;
        this.playSpinVueBridge();
      });
    },
    /**
     * 모바일에서 광고 시청이 완료되었을때 불리는 function
     * do ticket add rest ful apu call
     * native => Vue
     * @adType = "AD1","AD2","AD3" // 해당 값은 일단 유동적으로
     *            각게임마다 정해진 AD<NUM> 사용해볼것
     */
    addTicketCnt(adType) {
      create({
        adType: "AD2",
      }).then(({ data }) => {
        if (data.resultCode == "9000") {
          alert("채굴권 흭득에 실패했습니다. 잠시후 다시 시도해주세요.");
          return;
        }
        this.$store.commit("udtTicketCnt", data.ticketCnt);
        this.ticketCntView = data.ticketCntView;
        this.adTimeCheck();
        this.checkList();
      });
    },
    /**
     * 채굴권 갯수 확인 및 참여리스트
     */
    checkList() {
      check({
        gameType: "slot",
      }).then(({ data }) => {
        this.$store.commit("udtAccountCoin", data.accountCoin);
        this.ticketCntView = data.ticketCntView;
        this.userList = data.resultList;
        this.winInfoList = data.winInfoList;
        this.startRender = true;
        this.initJquery();
        setTimeout(function () {
          window.VueRoot.currentFusSpin();
        }, 1000);
      });
    },
    initJquery() {
      $(function () {
         if(this.isInitJquery){
            return;
         }
         this.isInitJquery = true;
         $('a[href="#"]').click(function (e) {
           e.preventDefault();
         });
         $(".help").click(function () {
           $(this).toggleClass("ed");
         });
         $(".modal-call").click(function (e) {
           e.preventDefault();
           $("body").addClass("modal-poped");
           var modalID = $(this).attr("rel");
           $("." + modalID).addClass("active");
         });
         $("a.close").click(function () {
           $(this).parent().parent().removeClass("active");
           $("body").removeClass("modal-poped");
         });
      });
    },
  },
};

function playSpin() {
  var sound = new Audio("ringtones/spinning.mp3");
  var ding = new Audio("ringtones/ding.wav");
  sound.play(); // Start play the sound after click button
  $(".spinner ul").playSpin({
    time: 2000,
    endNum: window.VueRoot.gameResult, //결과 정하기
    stopSeq: "leftToRight",
    //easing:'easeOutBounce',
    onEnd: function () {
      ding.play(); // Play ding after each number is stopped
    },
    onFinish: function () {
      sound.pause(); // To stop the looping sound is pause it
      setTimeout(function () {
        window.VueRoot.checkList();
        window.$("body").addClass("modal-poped");
        window.$(".modal.winner").addClass("active");
        window.VueRoot.spinEnable = true;
      }, 1000);
    },
  });
}
</script>

<style>
[v-cloak] {
  display: none;
}
</style>
